import { useState,  useEffect, createRef } from 'react';
import Config from '../Config';

function ZmienTermin(props)
{

    const [view, setView] = useState('btn');
    const [id, setId] = useState(props.id);
    const [data_prezentacji, setDataPrezentacji] = useState(props.def);

    const zmienGodzine = (e) => {
        setView("dialog");
    }

    const zamknij = (e) => {

        e.target.innerHTML = "...";
        
        setView("btn");
    }


    const zapisz = (e) => {
       
        e.target.innerHTML = "...";

        var dt = {   
            id: id,
            opcja: 'date',
            param: data_prezentacji
        }
    
        fetch( Config.url + '/rest_public,video_change_status', {
            method: 'POST', 
            body: JSON.stringify(dt), 
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.apiKey
            }
         })
         .then(res => res.json() )
         .then(res => {                       
         
                if(res.status == 'OK')
                {
                    alert("Informacja o zmianie terminu została wysłana.");
                    props.onDateChange( data_prezentacji );
                }else
                {
                    alert("Aktualnie nie możesz zmienić daty. Spróbuj później.");  
                }
    
         } )
         .catch(err => {
            console.log("Err " + err);
         });
              

    }


    const changeDataPrezentacji = (e ) => {
        var dt = e.target.value.replace('T',' ');
        setDataPrezentacji(dt);
        console.log(dt);
    }



    if(view == 'btn')
    {
        return <span className='btn' onClick={zmienGodzine}>Zmień termin</span>
    }

    return (
        <div className='dialog_termin'>
                <div className='dialog_window'>
                        <div className='label'>Wybierz nowy termin (8:00 - 21:00, pn./nd.)</div>
                        <div className='content'>

                                <fieldset>
                                  <input type="datetime-local" value={data_prezentacji} name="data_prezetnacji" onChange={changeDataPrezentacji} placeholder='RRRR-MM-DD GG:MM'  className='w100proc' />
                                </fieldset>

                        </div>
                        <div className='buttons'>
                            <span className='simply_link' onClick={zapisz}>Zapisz</span>
                            &nbsp;&nbsp; &nbsp;&nbsp; 
                            &nbsp;&nbsp; &nbsp;&nbsp; 
                            <span className='simply_link' onClick={zamknij}>Anuluj</span>                                                      
                        </div>
                </div>
        </div>
    )
}


export default ZmienTermin;